module.exports = __webpack_public_path__ + "static/media/bg_ts_front.fab34ce2.png";